module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('header', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-xs-6"
  }, [_c('p', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('picture', [_c('img', {
    attrs: {
      "src": _vm.props.acf.add_logo,
      "alt": "Updike Orthodontics"
    }
  })])])], 1)]), _c('div', {
    staticClass: "col-sm-8 col-xs-6"
  }, [_c('nav', {
    staticClass: "ccm-responsive-navigation original"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/practice"
    }
  }, [_vm._v("Practice")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/patient-info"
    }
  }, [_vm._v("Patient Info")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/treatment"
    }
  }, [_vm._v("Treatment")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/covid-19"
    }
  }, [_vm._v("COVID-19")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/news"
    }
  }, [_vm._v("News")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact-us"
    }
  }, [_vm._v("Contact Us")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/blog"
    }
  }, [_vm._v("Blog")])], 1), _vm._m(0)])]), _vm._m(1)])])]), _c('div', {
    attrs: {
      "id": "mobile-menu"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/practice"
    }
  }, [_vm._v("Practice")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/patient-info"
    }
  }, [_vm._v("Patient Info")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/treatment"
    }
  }, [_vm._v("Treatment")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/covid-19"
    }
  }, [_vm._v("COVID-19")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/news"
    }
  }, [_vm._v("News")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact-us"
    }
  }, [_vm._v("Contact Us")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/blog"
    }
  }, [_vm._v("Blog")])], 1), _vm._m(2)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "virtual-consult-btn"
  }, [_c('a', {
    attrs: {
      "href": "https://formsroostergrin.com/updikeortho/virtual-page/index.html",
      "target": "_blank"
    }
  }, [_vm._v("Virtual Consult")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ccm-responsive-menu-launch",
    attrs: {
      "onclick": "toggleMenu()"
    }
  }, [_c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "virtual-consult-btn-mobile"
  }, [_c('a', {
    attrs: {
      "href": "https://formsroostergrin.com/updikeortho/virtual-page/index.html",
      "target": "_blank"
    }
  }, [_vm._v("Virtual Consult")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6333127e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/header/header.pug
// module id = 560
// module chunks = 1